module.exports = __webpack_public_path__ + "media/images/icon_list/close-e94e902d2d01520338cedff49afa2af5.svg";